<template>
  <div v-if="showBars" class="c-book-title">
    <div
      v-if="responsive === 'desktop' && !connection"
      class="c-book-title__badge"
    >
      <offline-badge :color="'grey'"></offline-badge>
    </div>
  </div>
</template>

<script>
import offlineBadge from './OfflineBadge'

export default {
  name: 'book-title',

  components: {
    'offline-badge': offlineBadge,
  },

  props: {
    connection: {
      type: Boolean,
      default: true,
    },
    showBars: Boolean,
    responsive: {
      type: String,
      default: 'desktop',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_vars.scss';

.c-book-title {
  position: absolute; //TODO: temp solution so that title does not go in the way, needs to be adjusted (badge in other task)
  left: 50%;
  transform: translateX(-50%);
  padding: 1em;
  z-index: 10;
}

.c-book-title__badge {
  max-width: 30%;
}

@media screen and (min-width: 1366px) {
  .c-book-title__badge {
    max-width: 100%;
  }
}
</style>
